import { useQuery } from '@tanstack/react-query';

import { getIntegratedScrapeStatus } from '~apis/scrape';

export const IntegratedScrapeQueryStatusKeys = {
  default: () => ['integrated-scrape-status'],
};

export default function useGetIntegratedScrapeStatus(companyId: string) {
  return useQuery(
    IntegratedScrapeQueryStatusKeys.default(),
    () => getIntegratedScrapeStatus(companyId),
    { enabled: !!companyId },
  );
}
